import { PaymentMethodType, ThreeDsValues } from 'app/util/constants';
import { CheckoutRequest, Entity } from 'common/interface';
import { GACheckoutDTO, GAPurchaseDTO } from '../dtos/GACheckoutDTO';
import { getGAClientId } from 'app/util/analytics/analytics';

export const useGACheckoutDTOFactory = () => {
  const parseCheckoutToGACheckoutDTO = (checkout: CheckoutRequest, entity: Entity, value: number): GACheckoutDTO => {
    return {
      ga_client_id: getGAClientId(),
      checkout_id: checkout.id,
      live_mode: checkout.liveMode,
      checkout_type: checkout.type,
      is_recurrent: checkout.recurrent,
      needs_shipping_contact: checkout.needsShippingContact,
      can_not_expire: checkout.canNotExpire,
      value,
      currency: checkout.orderTemplate.currency,
      company_id: checkout.companyId,
      three_ds_mode: entity.threeDs ? entity.threeDs : ThreeDsValues.off,
      customer_id: checkout.orderTemplate.customerInfo?.customerId ?? '',
    };
  };

  const parseGAPurchaseDTO = (
    checkout: CheckoutRequest,
    entity: Entity,
    value: number,
    selectedPaymentMethod: PaymentMethodType,
  ): GAPurchaseDTO => {
    return {
      ...parseCheckoutToGACheckoutDTO(checkout, entity, value),
      payment_method: selectedPaymentMethod,
    };
  };
  return { parseCheckoutToGACheckoutDTO, parseGAPurchaseDTO };
};
